import { Navigate } from "react-router-dom";
import { useSurfaceAccess, type Surface } from "@/hooks/useSurfaceAccess";

// Research Hub surface gate (admins bypass via the has_surface_access RPC itself).
//
// AUDIENCE-SEPARATION (Phase 4 build-wall): extracted verbatim out of ProtectedRoute so the
// SHARED guard never names `useSurfaceAccess` or `/partner/research-hub`. This component is
// PROPRIETARY (it imports the has_surface_access RPC + names the research-hub redirect) and is
// composed ONLY inside the internal-only research route fragment (routes/researchRoutes.tsx).
// Rendered inside an already-authenticated <ProtectedRoute>, so auth/role/team have resolved by
// the time it mounts; it only adds the surface check — exactly as ProtectedRoute's inline
// `if (requiredSurface)` branch did before, byte-for-byte (same spinner, same redirect).
interface SurfaceGateProps {
  surface: Surface;
  children: React.ReactNode;
}

export const SurfaceGate = ({ surface, children }: SurfaceGateProps) => {
  const surfaceAccess = useSurfaceAccess(surface);

  // While the access check is in flight, hold on a quiet spinner rather than flashing the content.
  if (surfaceAccess.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
      </div>
    );
  }
  if (!surfaceAccess.data) {
    console.log("🚫 SurfaceGate: No access to research surface:", surface);
    return <Navigate to="/partner/research-hub" replace />;
  }
  return <>{children}</>;
};
